import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';

import { FormGroup, Select } from 'components/FormElements';
import ChatConfigurationService from 'services/ChatConfigurationService';
import { toggleLoading, toggleAlertError } from 'stores/actions';
import { greaterOrEqual, required } from 'constants/InputErrors';

const hours = [
  { id: 1, name: '1' },
  { id: 2, name: '2' },
  { id: 3, name: '3' },
  { id: 4, name: '4' },
  { id: 5, name: '5' },
  { id: 6, name: '6' },
  { id: 7, name: '7' },
  { id: 8, name: '8' },
  { id: 9, name: '9' },
  { id: 10, name: '10' },
  { id: 11, name: '11' },
  { id: 12, name: '12' },
  { id: 13, name: '13' },
  { id: 14, name: '14' },
  { id: 15, name: '15' },
  { id: 16, name: '16' },
  { id: 17, name: '17' },
  { id: 18, name: '18' },
  { id: 19, name: '19' },
  { id: 20, name: '20' },
  { id: 21, name: '21' },
  { id: 22, name: '22' },
  { id: 23, name: '23' },
  { id: 24, name: '24' },
];

class ChatConfig extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {}
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    ChatConfigurationService.getChatConfig().then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.errors ) this.props.toggleAlertError( response.errors );

      this.setState( {
        data: response.data
      } )
    } );
  }

  submitForm( data ) {
    const { toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );

    toggleLoading( true );

    ChatConfigurationService.updateChatConfig( this.state.data.id, data ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      toggleAlertError( 'Information updated' );
      toggleLoading( false );
    } )
  }

  render() {
    return (
      <div className="box box-default">
        <div className="box-header">{<Translate id="chatConfiguration"/>}</div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values ) => ( {
              mondayFrom: required( values.mondayFrom ),
              tuesdayFrom: required( values.tuesdayFrom ),
              wednesdayFrom: required( values.wednesdayFrom ),
              thursdayFrom: required( values.thursdayFrom ),
              fridayFrom: required( values.fridayFrom ),
              saturdayFrom: required( values.saturdayFrom ),
              sundayFrom: required( values.sundayFrom ),
              mondayTo: required( values.mondayTo )
                ? required( values.mondayTo ) : greaterOrEqual( values.mondayTo, values.mondayFrom ),
              tuesdayTo: required( values.tuesdayTo )
                ? required( values.tuesdayTo ) : greaterOrEqual( values.tuesdayTo, values.tuesdayFrom ),
              wednesdayTo: required( values.wednesdayTo )
                ? required( values.wednesdayTo ) : greaterOrEqual( values.wednesdayTo, values.wednesdayFrom ),
              thursdayTo: required( values.thursdayTo )
                ? required( values.thursdayTo ) : greaterOrEqual( values.thursdayTo, values.thursdayFrom ),
              fridayTo: required( values.fridayTo )
                ? required( values.fridayTo ) : greaterOrEqual( values.fridayTo, values.fridayFrom ),
              saturdayTo: required( values.saturdayTo )
                ? required( values.saturdayTo ) : greaterOrEqual( values.saturdayTo, values.saturdayFrom ),
              sundayTo: required( values.sundayTo )
                ? required( values.sundayTo ) : greaterOrEqual( values.sundayTo, values.sundayFrom ),
            } )}
          >
            {( { submitForm } ) =>
              <form onSubmit={submitForm} className="row">
                <div className="col-md-4">
                  <p className="font-weight-bold mb-1">
                    <Translate id="monday"/>
                  </p>
                  <div className="row pl-2">
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="fromHour"/></label>
                      <Select field="mondayFrom" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="toHour"/></label>
                      <Select field="mondayTo" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                  </div>
                </div>

                <div className="col-md-4">
                  <p className="font-weight-bold mb-1">
                    <Translate id="tuesday"/>
                  </p>
                  <div className="row pl-2">
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="fromHour"/></label>
                      <Select field="tuesdayFrom" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="toHour"/></label>
                      <Select field="tuesdayTo" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                  </div>
                </div>

                <div className="col-md-4">
                  <p className="font-weight-bold mb-1">
                    <Translate id="wednesday"/>
                  </p>
                  <div className="row pl-2">
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="fromHour"/></label>
                      <Select field="wednesdayFrom" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="toHour"/></label>
                      <Select field="wednesdayTo" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                  </div>
                </div>

                <div className="col-md-4">
                  <p className="font-weight-bold mb-1">
                    <Translate id="thursday"/>
                  </p>
                  <div className="row pl-2">
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="fromHour"/></label>
                      <Select field="thursdayFrom" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="toHour"/></label>
                      <Select field="thursdayTo" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                  </div>
                </div>

                <div className="col-md-4">
                  <p className="font-weight-bold mb-1">
                    <Translate id="friday"/>
                  </p>
                  <div className="row pl-2">
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="fromHour"/></label>
                      <Select field="fridayFrom" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="toHour"/></label>
                      <Select field="fridayTo" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                  </div>
                </div>

                <div className="col-md-4">
                  <p className="font-weight-bold mb-1">
                    <Translate id="saturday"/>
                  </p>
                  <div className="row pl-2">
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="fromHour"/></label>
                      <Select field="saturdayFrom" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="toHour"/></label>
                      <Select field="saturdayTo" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                  </div>
                </div>

                <div className="col-md-4">
                  <p className="font-weight-bold mb-1">
                    <Translate id="sunday"/>
                  </p>
                  <div className="row pl-2">
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="fromHour"/></label>
                      <Select field="sundayFrom" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="toHour"/></label>
                      <Select field="sundayTo" className="form-control" placeholder=""
                              options={hours}
                              suffixIcon={<i className="fa fa-clock-o"/>}/>
                    </FormGroup>
                  </div>
                </div>

                <div className="col-md-12 text-right mt-4">
                  <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( ChatConfig );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/chat/index.js